import type { RouteObject } from 'react-router';
import MainLayout from '~/ui/layout/MainLayout';
import { BookingFlowPage } from '~/pages/booking/BookingFlowPage';
import { BookingConfirmationPage } from '~/pages/booking/BookingConfirmationPage';
import { BookingDetailPage } from '~/pages/booking/BookingDetailPage';
import { BookingProvider } from '~/services/internalApi/booking';

/**
 * Booking Routes
 * Handles bay bookings, booking management, and confirmations
 * 
 * Layout: MainLayout
 * Auth Guard: requireAuth + requireOnboardingCompleted
 * 
 * Note: BookingProvider wraps booking routes to manage booking state
 * (selected date, time slot, bay, etc.) with session persistence.
 */
export const bookingRoutes: RouteObject[] = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: (
          <BookingProvider>
            <BookingFlowPage />
          </BookingProvider>
        ),
      },
      {
        path: '/booking/confirmed/:bookingId',
        element: <BookingConfirmationPage />,
      },
      {
        path: 'bookings/:bookingId',
        element: <BookingDetailPage />,
      },
    ],
  },
  // TODO: Implement additional booking routes
  // Example structure from mobile-app:
  // {
  //   path: 'bookings',
  //   element: <MainLayout />,
  //   loader: requireAuth,
  //   children: [
  //     {
  //       index: true,
  //       element: <BookingsPage />,
  //     },
  //     {
  //       path: ':id',
  //       element: <BookingDetailPage />,
  //     },
  //   ],
  // },
  // {
  //   path: 'create-booking',
  //   element: <MainLayout />,
  //   element: <CreateBookingPage />,
  //   loader: requireAuth,
  //   children: [
  //     {
  //       path: ':bookingId',
  //       element: <BayInfoPage />,
  //     },
  //   ],
  // },
  // {
  //   path: 'bays',
  //   element: <BaysPage />,
  //   loader: requireAuth,
  // },
  // {
  //   path: 'bays/:id/book',
  //   element: <BookBayPage />,
  //   loader: requireAuth,
  // },
  // {
  //   path: 'confirm-booking',
  //   element: <ConfirmBookingPage />,
  //   loader: requireAuth,
  // },
];
